import { render, staticRenderFns } from "./ScheduleDiagnostic.vue?vue&type=template&id=2dfbda12"
import script from "./ScheduleDiagnostic.vue?vue&type=script&lang=js"
export * from "./ScheduleDiagnostic.vue?vue&type=script&lang=js"
import style0 from "./ScheduleDiagnostic.vue?vue&type=style&index=0&id=2dfbda12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports